// Custom hook for session expiry tracking

import { useState, useEffect } from 'react';

const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds
const WARNING_THRESHOLD = 5 * 60 * 1000; // Show warning 5 minutes before expiry

export function useSession() {
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const sessionStartTime = parseInt(localStorage.getItem('sessionStart') || '0');
      
      if (sessionStartTime === 0) {
        // No session active
        setTimeRemaining(null);
        setShowWarning(false);
        return;
      }
      
      const elapsed = Date.now() - sessionStartTime;
      const remaining = SESSION_DURATION - elapsed;

      setTimeRemaining(remaining);
      setShowWarning(remaining > 0 && remaining < WARNING_THRESHOLD);

      if (remaining <= 0) {
        // Session expired
        localStorage.removeItem('sessionToken');
        localStorage.removeItem('sessionStart');
        window.location.href = '/';
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return { timeRemaining, showWarning };
}
